import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export interface DiscoverPrompt {
  id: number;
  prompt_text: string;
  category: string;
}

export function useDiscoverPrompts(limit = 8) {
  return useQuery({
    queryKey: ["discover-prompts"],
    queryFn: () => apiFetch<DiscoverPrompt[]>(`/api/discover-prompts?limit=${limit}`),
    staleTime: 5 * 60 * 1000, // 5 min cache — prompts don't change often
  });
}
